import { InlineSpinner } from "components/InlineSpinner";
import React from "react";

export const RouteLoader: React.FC = () => (
  <div className="route-loading d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
    <InlineSpinner />
  </div>
);
